const createMuiAutocomplete = () => ({
  styleOverrides: {
    listbox: {
      padding: 0
    }
  }
});
export {
  createMuiAutocomplete as default
};
